import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import LegacyQrRedirect from "./LegacyQrRedirect";
import QrRouteGuard from './QrRouteGuard';
import Loading from '@components/Loading';

const Home = lazy(() => import('@pages/home/Home'));
const Cart = lazy(() => import('@pages/cart/Cart'));
const SearchFood = lazy(() => import('@pages/searchFood/SearchFood'));
const FoodDetail = lazy(() => import('@pages/food/FoodDetail'));
const OrderList = lazy(() => import('@pages/order/OrderList'));
const BannerDetail = lazy(() => import('@pages/banner/BannerDetail'));
const ExpiredContract = lazy(() => import('@pages/expiredContract/ExpiredContract'));
const ServiceInactive = lazy(() => import('@pages/serviceInactive/ServiceInactive'));
const InvalidQr = lazy(() => import('@pages/invalidQr/InvalidQr'));

const guarded = element => <QrRouteGuard>{element}</QrRouteGuard>;

const routeDefs = [
    { pathSuffix: '/expired_contract', element: <ExpiredContract /> },
    { pathSuffix: '/service_inactive', element: <ServiceInactive /> },
    { pathSuffix: '/invalid_qr', element: <InvalidQr /> },

    { pathSuffix: '/:tokenqr', element: <Home /> },
    { pathSuffix: '/:tokenqr/cart', element: guarded(<Cart />) },
    { pathSuffix: '/:tokenqr/search_food', element: guarded(<SearchFood />) },
    { pathSuffix: '/:tokenqr/food_detail/:item_no', element: guarded(<FoodDetail />) },
    { pathSuffix: '/:tokenqr/order_list', element: guarded(<OrderList />) },
    { pathSuffix: '/:tokenqr/banner_detail/:banner_no', element: guarded(<BannerDetail />) },

    /* Compatibility routes for already-deployed links and old payment callbacks. */
    { pathSuffix: '/cart', element: <LegacyQrRedirect page="cart" /> },
    { pathSuffix: '/search_food', element: <LegacyQrRedirect page="search" /> },
    { pathSuffix: '/food_detail/:item_no', element: <LegacyQrRedirect page="food" paramName="item_no" /> },
    { pathSuffix: '/order_list', element: <LegacyQrRedirect page="orders" /> },
    { pathSuffix: '/banner_detail/:event_no', element: <LegacyQrRedirect page="banner" paramName="event_no" /> },
];

const Router = () => {
    return (
        <Suspense fallback={<Loading />}>
            <Routes>
                {['/qr', ''].flatMap(prefix =>
                    routeDefs.map(def => (
                        <Route
                            key={`${prefix}${def.pathSuffix}`}
                            path={`${prefix}${def.pathSuffix}`}
                            element={def.element}
                        />
                    ))
                )}
                <Route path="*" element={<LegacyQrRedirect />} />
            </Routes>
        </Suspense>
    );
};

export default Router;
